import { openLogin } from '@/utils/sso';

const LOCAL_PORT = 'http://127.0.0.1:3000'

export default ({ $axios }) => {
  $axios.defaults.timeout = 10000;

  // 环境变量
  if (process.server) $axios.defaults.baseURL = process.env.NUXT_ENV_AXIOS_BASE_URL || LOCAL_PORT;

  // 请求拦截器
  $axios.onRequest((config) => config)

  // 响应拦截器
  $axios.onResponse((resp) => Promise.resolve(resp));

  $axios.onError((error) => {
    const code = parseInt(error.response && error.response.status, 10);
    if (code === 401) {
      openLogin('login');
    }
    return Promise.reject(error);
  });
};
